import type { CompanyType, QuickscanAnswers } from '@wtta/scoring'

// NOTE: dit bestand spiegelt het v1 unsigned-token formaat van
// `clients/quickscan-widget/src/lib/token.ts`. In v2 migreren we naar
// signed JWT (HS256) en hoort deze logica in een gedeelde package
// `@wtta/quickscan-token`. Houden tot dan in sync — afgedekt door
// `__tests__/token.test.ts` met dezelfde fixtures als de widget.

export interface QuickscanTokenPayload {
  v: 1
  ct: CompanyType
  a: QuickscanAnswers
  iat: number
  exp: number
}

export function decodeUnsignedToken(token: string): QuickscanTokenPayload | null {
  try {
    const decoded = base64UrlDecode(token)
    const parsed = JSON.parse(decoded) as QuickscanTokenPayload
    if (parsed.v !== 1) return null
    if (typeof parsed.exp !== 'number') return null
    if (parsed.exp * 1000 < Date.now()) return null
    if (parsed.ct !== 'uitlener' && parsed.ct !== 'inlener') return null
    if (typeof parsed.a !== 'object' || parsed.a === null) return null
    return parsed
  } catch {
    return null
  }
}

function base64UrlDecode(input: string): string {
  const padded = input.replace(/-/g, '+').replace(/_/g, '/').padEnd(
    Math.ceil(input.length / 4) * 4,
    '=',
  )
  const binary = atob(padded)
  const bytes = new Uint8Array(binary.length)
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i)
  }
  return new TextDecoder().decode(bytes)
}
